var map = {
	"./classManage.svg": "83f1",
	"./classNum.svg": "0524",
	"./dashboard.svg": "dea0",
	"./download.svg": "7fd9",
	"./edit.svg": "9e05",
	"./highest.svg": "fa78",
	"./info.svg": "d8a0",
	"./lock.svg": "7094",
	"./score.svg": "a77b",
	"./student.svg": "df85",
	"./studentManage.svg": "beb3",
	"./tool.svg": "761a",
	"./user.svg": "99a7",
	"./wechat.svg": "26f8",
	"./workManage.svg": "37f9",
	"./下载.svg": "0405",
	"./作品管理.svg": "6de3",
	"./创作工具.svg": "b299",
	"./学生主页-侧边栏-我的作品.svg": "1af5",
	"./学生主页-我的作品.svg": "2553",
	"./学生主页课堂表现.svg": "9902",
	"./学生管理.svg": "11a0",
	"./班级管理.svg": "f0b9",
	"./离线创作工具.svg": "6980"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49ab";